:host {
  display: inline-block;
  /** @prop --fieldset-foreground-color: Defines the foreground color. */
  --fieldset-foreground-color: var(--dnn-color-foreground, #000);
  /** @prop --fieldset-background-color: Defines the background color. */
  --fieldset-background-color: var(--dnn-color-background, #fff);
  /** @prop --focus-color: Defines the color when the component is focused. */
  --fieldset-focus-color: var(--dnn-color-primary, #3792ED);
  /** @prop --danger-color: Defines the danger color used for invalid data. */
  --fieldset-danger-color: var(--dnn-color-danger, #900);
  /** @prop --control-radius: Defines the radius for the control corners. */
  --fieldset-control-radius: var(--dnn-controls-radius, 3px);
}

.container {
  border: 1px solid var(--fieldset-foreground-color, #000);
  border-radius: var(--fieldset-control-radius, 3px);
  padding: 0.75em;
  display: flex;
  justify-content: space-between;
  gap: 0.1em;
  position: relative;
  background-color: var(--fieldset-background-color);
  margin-top: 1em;
  line-height: 1em;
}
.container .resizer {
  width: 100%;
}
.container .inner-container {
  position: relative;
  width: 100%;
  background-color: var(--fieldset-background-color);
  height: calc(100% - 1em);
}
.container label {
  display: inline-flex;
  position: absolute;
  opacity: 1;
  transition: all 150ms ease-in-out;
  left: 0.5em;
  top: -1.5em;
  padding: 0 0.5em;
  background-color: var(--fieldset-background-color);
  white-space: nowrap;
  max-width: 100%;
  border-radius: var(--fieldset-control-radius);
  font-size: 1em;
  margin-top: 1em;
  z-index: 1;
  pointer-events: none;
  line-height: 1em;
}
.container.focused {
  border: 1px solid var(--fieldset-focus-color);
  box-shadow: 0 0 0 1px var(--fieldset-focus-color);
}
.container.focused.invalid {
  border: 1px solid var(--fieldset-danger-color);
  box-shadow: 0 0 0 1px var(--fieldset-danger-color);
}
.container.focused input {
  color: var(--fieldset-foreground-color, #000);
}
.container.float-label label {
  opacity: 0.6;
  left: 0;
  top: calc(50% - 0.5em);
  margin-top: 0;
}
.container.disabled {
  opacity: 0.5;
}
.container.invalid {
  border-color: var(--fieldset-danger-color);
}

.help-text, .error-message {
  font-style: italic;
  opacity: 0.7;
  font-size: 0.8em;
  margin: 0.25em;
}

.error-message {
  color: var(--fieldset-danger-color);
  font-style: normal;
  font-weight: bold;
}